import {Grid, Theme, Typography} from '@material-ui/core'
import React                     from 'react'
import {Barrister}               from '../../entities/barrister'
import theme                     from '../theme'
import {makeStyles}              from '@material-ui/core/styles'
import {GatsbyImage}             from "gatsby-plugin-image";
import {Link}                    from 'gatsby'
import SanityImage               from 'gatsby-plugin-sanity-image'

const useStyles = makeStyles((theme: Theme) => ({
    barristerCardContainer: {
        flex: '0 1 300px'
    },
    barristerCard: {
        position: 'relative',
        cursor: 'pointer',
        // background: 'rgba(109, 110, 113, 0.3)',
        background: '#FFF',
        width: '300px',
        height: '400px',
        maxWidth: '300px',
        maxHeight: '450px'
        // margin: '.4em'
    },
    cardTitle: {
        margin: 0,
        color: '#000',
        width: '100%',
        fontWeight: 600,
        fontSize: '17px'
    },
    cardDetailsContainer: {
        background: '#E5E5E5',
        width: '100%',
        position: 'absolute',
        height: '100px',
        bottom: 0,
        left: 0,
        transition: '0.5s',
        padding: '1em'
    },
    cardDetailsText: {
        textAlign: 'right',
        color: '#000',
        fontSize: '18px',
        textDecoration: 'none',
        lineHeight: 1.2,
        '& strong': {
            fontWeight: 600
        }
    },
    shortlistButton: {
        transition: '0.5s',
        color: '#FFF',
        borderRadius: '0% 20% 20% 0%',
        '&:hover': {
            color: 'goldenrod'
        }
    }
}))

interface BarristerCardProps {
    barrister: Barrister
    placeholderImage: any
}

const BarristerCard = (props: BarristerCardProps, ref) => {

    const classes = useStyles(theme)
    const {barrister, placeholderImage} = props

    /*
        const renderShortListButton = () => (
            <Button disableFocusRipple={true} disableTouchRipple={true} disableElevation={true}
                    className={classes.shortlistButton}
                    onClick={(event: MouseEvent) => handleShortlistClick(event, barrister._id)}>
                {
                    shortlisted ? (
                        <span style={{
                            color: shortlisted ? 'none' : 'goldenrod',
                            paddingTop: '9px'
                        }}><CheckCircleOutlineIcon /></span>
                    ) : (<span style={{ paddingTop: '9px' }}><RadioButtonUnchecked /></span>)
                }
            </Button>
        )
    */

    return (
        <article>
            {
                barrister && (
                              <div className={classes.barristerCardContainer}>
                                  <Link to={`/barristers/${barrister.slug.current}`}>
                                      <div className={classes.barristerCard}>
                                          {
                                              barrister.barristerPortrait ? (
                                                  <SanityImage
                                                      width={320}
                                                      {...barrister.barristerPortrait}
                                                      style={
                                                          {
                                                              overflow: 'hidden',
                                                              position: 'relative',
                                                              margin: 0,
                                                              width: '100%',
                                                              height: '100%',
                                                              objectFit: 'cover'
                                                          }}
                                                      options={{
                                                          projectId: 'hf5dghso',
                                                          dataset: 'production',
                                                          defaultImageConfig: {
                                                              auto: "format",
                                                              fit: "max",
                                                              width: 320,
                                                              height: 480
                                                          }
                                                      }}
                                                      imgStyle={{
                                                          display: 'block',
                                                          objectPosition: `0 ${(barrister.barristerPortrait.crop ? (barrister.barristerPortrait.crop.bottom * 100).toString() : '0') || 0}%`,
                                                          // left: `-${barrister.barristerPortrait.hotspot ? (barrister.barristerPortrait.hotspot.x * 100) : '0'}px`,
                                                          width: `300px`
                                                          // top: `-${barrister.barristerPortrait.hotspot ? (barrister.barristerPortrait.hotspot.y * 100) : '0'}px`,
                                                      }}/>
                                              ) : (
                                                  <GatsbyImage
                                                      image={placeholderImage}
                                                      style={{
                                                          overflow: 'hidden',
                                                          position: 'relative',
                                                          margin: 0,
                                                          width: '100%',
                                                          height: '100%'
                                                      }}
                                                      imgStyle={{display: 'block', left: `0`, width: `900px`, top: '-30px'}}
                                                      alt={'Barrister'}/>
                                              )
                                          }
                                          <div className={classes.cardDetailsContainer}>
                                              <Grid container style={{height: '100%'}} alignItems={'flex-start'}
                                                    justify={'flex-start'}>
                                                  <Grid item container alignItems={'center'} xs={8}>
                                                      <Typography className={classes.cardTitle} component={'h3'} variant="h6">
                                                          {barrister.preferredName}
                                                      </Typography>
                                                  </Grid>
                                                  <Grid item xs={4} style={{height: '100%'}} container direction={'column'}
                                                        alignItems={'flex-end'}
                                                        justify={'flex-end'}>
                                                      {
                                                          barrister.barristerGroup !== 'academicMember' &&
                                                          barrister.practices &&
                                                          barrister.practices[0] && (
                                                              <Typography component={'span'} className={classes.cardDetailsText}>
                                                                  Bar <strong>{barrister.practices[0] && barrister.practices[0].joinedBarYear}</strong>
                                                                  {
                                                                      barrister.practices[0].takenSilk && barrister.practices[0].silkYear && (
                                                                                                           <>
                                                                                                               <br/>
                                                                                                               <Typography component={'span'}
                                                                                                                           className={classes.cardDetailsText}>
                                                                                                                   Silk <strong>{barrister.practices[0].silkYear}</strong>
                                                                                                               </Typography>
                                                                                                           </>
                                                                                                       )
                                                                  }
                                                              </Typography>
                                                          )
                                                      }

                                                  </Grid>
                                              </Grid>
                                              <Grid item container>
                                              </Grid>
                                          </div>
                                      </div>
                                  </Link>
                              </div>
                          )
            }
        </article>
    );
}


export default BarristerCard
